import { Badge } from "@/components/ui/badge";

const MAP = {
  Approved: { cls: "bg-emerald-50 text-emerald-800 border-emerald-200", dot: "bg-emerald-600" },
  Pending: { cls: "bg-amber-50 text-amber-800 border-amber-200", dot: "bg-amber-500" },
  Rejected: { cls: "bg-rose-50 text-rose-800 border-rose-200", dot: "bg-rose-600" },
  Draft: { cls: "bg-stone-100 text-stone-600 border-stone-200", dot: "bg-stone-400" },
  Contracted: { cls: "bg-blue-50 text-blue-800 border-blue-200", dot: "bg-blue-600" },
  "Non-Contracted": { cls: "bg-stone-100 text-stone-600 border-stone-200", dot: "bg-stone-400" },
};

export function StatusBadge({ status, testid }) {
  const s = MAP[status] || MAP.Draft;
  return (
    <span data-testid={testid} className={`inline-flex items-center gap-1.5 text-xs px-2.5 py-1 rounded-full border font-medium ${s.cls}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${s.dot}`} />
      {status}
    </span>
  );
}

export function SalesBadge({ yes }) {
  return (
    <span className={`inline-flex items-center gap-1.5 text-xs px-2.5 py-1 rounded-full border font-medium ${
      yes ? "bg-emerald-50 text-emerald-800 border-emerald-200" : "bg-rose-50 text-rose-800 border-rose-200"
    }`}>
      <span className={`h-1.5 w-1.5 rounded-full ${yes ? "bg-emerald-600" : "bg-rose-600"}`} />
      {yes ? "Yes" : "No"}
    </span>
  );
}
